/**
 * Races one promise against a timeout.
 */
export async function run_with_timeout<TValue>(
  operation: Promise<TValue>,
  timeout_ms: number,
  error_message: string
): Promise<TValue> {
  return await new Promise<TValue>((resolve, reject): void => {
    const timeout_handle = setTimeout((): void => {
      reject(new Error(error_message));
    }, timeout_ms);

    void operation.then(
      (value: TValue): void => {
        clearTimeout(timeout_handle);
        resolve(value);
      },
      (error: unknown): void => {
        clearTimeout(timeout_handle);
        reject(error instanceof Error ? error : new Error(String(error)));
      }
    );
  });
}
